import { FieldBox } from "./FieldBox-DdSdJ3ZN.js";
import { useId } from "react";
import { cva } from "class-variance-authority";
import { jsx, jsxs } from "react/jsx-runtime";
import { Root, Thumb } from "@radix-ui/react-switch";
// src/components/Switch/styles.ts
const switchVariants = cva([
	"tailwindcss-preflight",
	"tw:shrink-0",
	"tw:cursor-pointer",
	"tw:disabled:cursor-not-allowed",
	"tw:disabled:opacity-disabled",
	"tw:peer",
	"tw:inline-flex",
	"tw:items-center",
	"tw:w-9",
	"tw:h-5",
	"tw:rounded-full",
	"tw:border",
	"tw:border-transparent",
	"tw:bg-input",
	"tw:transition-colors",
	"tw:data-[state=checked]:bg-primary",
	"tw:focus-visible:outline-hidden",
	"tw:focus-visible:border-primary",
	"tw:focus-visible:ring-3",
	"tw:focus-visible:ring-ring/50"
]);
const thumbVariants = cva([
	"tw:block",
	"tw:shrink-0",
	"tw:pointer-events-none",
	"tw:bg-white",
	"tw:rounded-full",
	"tw:size-4",
	"tw:shadow-sm",
	"tw:transition-transform",
	"tw:data-[state=checked]:translate-x-[16px]",
	"tw:data-[state=unchecked]:translate-x-0.5"
]);
// src/components/Switch/Switch.tsx
const Switch = ({ ref, className, disabled = false, id: idProp, children, description, variant, position, ...props }) => {
	const fallbackId = useId();
	const id = idProp?.toString() ?? fallbackId;
	const switchElement = /* @__PURE__ */ jsx(Root, {
		...props,
		ref,
		id,
		disabled,
		className: switchVariants({ className }),
		children: /* @__PURE__ */ jsx(Thumb, { className: thumbVariants() })
	});
	if (!children) return switchElement;
	return /* @__PURE__ */ jsxs(FieldBox, {
		htmlFor: id,
		variant,
		position,
		control: switchElement,
		children: [/* @__PURE__ */ jsx(FieldBox.Title, { children }), description && /* @__PURE__ */ jsx(FieldBox.Description, { children: description })]
	});
};
export { Switch };

//# sourceMappingURL=Switch-DONWW7ju.js.map